import { proceduresSagas } from 'common/utils/commonSagaCreators';

import { actionTypes } from '../reducer';

export default proceduresSagas.createGetProcedureSaga(actionTypes.procedure);
